import { DOCUMENT, ElementRef, Inject, Renderer2, inject } from '@angular/core';

import { MenuItems } from "src/app/components/dynamic-header/category/header-data";
import { MenuCollapseService } from "src/app/components/dynamic-header/services/menu-collapse.service";
import { NAVIGATION_PATH_BY_CHOICE, SEARCH_QUERY_PARAM_KEYS, path_based_links, search_url_links } from "src/app/core/constants/dynamic-click-actions.constant";
import { BrowserApiService } from "src/app/core/services/browser-api/browser-api.service";
import { PlatformService } from "src/app/core/services/platform/platform.service";
import { UserService } from "src/app/core/services/user/user.service";
import { ClickActionChoices } from "src/app/home/models/home.model";
import { ClickActionChoiceValue } from "src/app/shared/class/link-handler.class";
import { CommonHeaderFeature } from "../common-header-feature/common-header";

export class DynamicHeaderCommon extends CommonHeaderFeature {
  constructor(
    protected override renderer: Renderer2,
    protected override menuCollapseService: MenuCollapseService,
    protected override elementRef: ElementRef,
    protected override platformService: PlatformService,
    @Inject(DOCUMENT) protected override document: Document,
    private browserApiService: BrowserApiService
  ) {
    super();
  }

  // Override userService to ensure proper injection in child classes
  protected override userService = inject(UserService);

  // Method to refresh user data in child classes
  protected refreshUserInChild(): void {
    this.refreshUserData();
  }

  navigateByChoice(staticMenu: MenuItems) {
    const click_action_choice_value = staticMenu['data-click_action_value']?.length ? JSON.parse(staticMenu['data-click_action_value']) : '';
    const clickActionChoice = staticMenu['data-click_action_choice'] as ClickActionChoices;

    if (clickActionChoice || click_action_choice_value) {
      this.redirectToNewTab(clickActionChoice, click_action_choice_value)

    }
  }

  redirectToNewTab(clickActionChoice: ClickActionChoices, addedClickActionValue: ClickActionChoiceValue) {
    const location = this.browserApiService.getLocation();
    let new_url_to_redirect = (location?.origin ?? '') + '/' + NAVIGATION_PATH_BY_CHOICE[clickActionChoice];
    if (search_url_links.includes(clickActionChoice)) {
      new_url_to_redirect = new_url_to_redirect + '/?' + [SEARCH_QUERY_PARAM_KEYS[clickActionChoice]] + '=' + addedClickActionValue?.id;
    } else if (path_based_links.includes(clickActionChoice)) {
      new_url_to_redirect = new_url_to_redirect + '/' + addedClickActionValue?.url_path
    } else if (clickActionChoice === ClickActionChoices.link_url) {
      this.browserApiService.open(addedClickActionValue?.id, '_blank')
      return
    }
    this.browserApiService.open(new_url_to_redirect);
  }
}